/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:55:29
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-19 11:06:23
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\testee\mutations.js
 */
import * as MUTATIONTYPES from '../mutationTypes'
import * as STATETYPES from '../stateTypes'
const mutations = {
	[MUTATIONTYPES.SETTESTEEFORM](state, data) {
		state[STATETYPES.TESTEEFORM] = data
	},
	[MUTATIONTYPES.SETTESTEEDETAIL](state, data) {
		state[STATETYPES.TESTEEDETAIL] = data
	}
}
export default mutations